export default __webpack_public_path__ + "static/SCROLL_10-ed5c451038d7501d1ecaec074071c79b.png";